// extracted by mini-css-extract-plugin
module.exports = {"h1":"h1__1kqIK","h2":"h2__3ldhW","h3":"h3__3RSwf"};